<template>
  <div class="app-container">
    <el-card class="box-card">
      <div class="tab-box">
        <span :class="{'active': orderToday === 1}" @click="handleTabDate(1)">全部</span>
        <span :class="{'active': orderToday === 2}" @click="handleTabDate(2)">今天</span>
        <span :class="{'active': orderToday === 3}" @click="handleTabDate(3)">昨天</span>
        <span :class="{'active': orderToday === 4}" @click="handleTabDate(4)">近7天</span>
        <span :class="{'active': orderToday === 5}" @click="handleTabDate(5)">近30天</span>
        <el-date-picker @change="changeDate" v-model="dateTime" size="small" type="datetimerange" value-format="yyyy-MM-dd HH:mm:ss" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
      </div>
      <el-table v-loading="listLoading" :data="list" @selection-change="selectionChange" @sort-change="sortChange">
        <!-- <el-table-column type="selection" width="50" /> -->
        <el-table-column label="任务ID" prop="id" align="center" />
        <el-table-column label="任务标题 " prop="title" align="center" />
        <el-table-column label="任务执行进度 " prop="speed" align="center">
          <template slot-scope="{row}">
            <el-progress :percentage="row.speed" :text-inside="true" :stroke-width="15"></el-progress>
          </template>
        </el-table-column>
        <el-table-column label="任务执行状态 " prop="state" align="center" show-overflow-tooltip>
          <template slot-scope="{row}">
            <span v-if="row.state === 1">执行成功</span>
            <span v-if="row.state === 2">执行失败<br /> <el-link type="primary" @click="handleShow(row)">{{row.errorLog}}</el-link></span>
            <span v-if="!row.state">执行中</span>
          </template>
        </el-table-column>
        <el-table-column label="任务开始时间" prop="startTime" sortable="custom" align="center" />
        <el-table-column label="任务结束时间" prop="endTime" sortable="custom" align="center" />
        <el-table-column label="操作时间" prop="operatedTime" sortable="custom" align="center" />
        <el-table-column label="操作人" prop="operatedName" align="center" />
        <!-- <el-table-column label="操作" align="center" fixed="right" >
          <template slot-scope="{row}">
            <el-button type="text"  v-if="row.state === 1 || row.state === 2">详情</el-button>
          </template>
        </el-table-column> -->
      </el-table>
      <pagination v-show="total>0" :total="total" :pageNo.sync="query.pageNo" :pageSize.sync="query.pageSize" @pagination="doQueryList" />
    </el-card>
    <task-show ref="taskShow" />
  </div>
</template>

<script>
import sysTaskApi from '@/api/sys/sysTask'
import Pagination from '@/components/Pagination'
import { timeForMat } from '@/utils/index'
import taskShow from './show.vue'
export default {
  components: {
    Pagination,
    taskShow
  },
  data() {
    return {
      list: [],
      total: 0,
      listLoading: true,
      query: {
        pageNo: 1,
        pageSize: 10,
      },
      startTime: '',
      endTime: '',
      selectItems: [],
      orderToday: 1,
      dateTime: []
    }
  },
  created() {
    this.doQueryList({ pageNo: 1 })
  },
  methods: {
    handleTabDate(type) {
      if (this.orderToday === type) return
      this.dateTime = []
      this.orderToday = type;
      if (type === 1) {
        this.startTime = ''
        this.endTime = ''
      } else if (type === 2) {
        this.startTime = timeForMat('0')[0]
        this.endTime = timeForMat('0')[0]
      } else if (type === 3) {
        this.startTime = timeForMat('1')[0]
        this.endTime = timeForMat('1')[0]
      } else if (type === 4) {
        this.startTime = timeForMat('7')[0]
        this.endTime = timeForMat('7')[1]
      } else if (type === 5) {
        this.startTime = timeForMat('30')[0]
        this.endTime = timeForMat('30')[1]
      }
      this.doQueryList({})
    },
    changeDate() {
      if (!this.dateTime) return
      if (this.dateTime && !this.dateTime.length) return
      this.orderToday = 0;
      this.query.endTime = this.dateTime[0]
      this.query.startTime = this.dateTime[1]
      this.doQueryList({ pageNo: 1 })
    },
    /**
     * 选择框变化
     */
    selectionChange(val) {
      this.selectItems = val
    },
    /**
     * 触发后端排序
     */
    sortChange({ prop, order }) {
      const sortKeyMap = {
        // 'createdTime': 'createdTimeSortSign',
        'operatedTime': 'operatedTimeSortSign'
      }
      for (var k in sortKeyMap) {
        const sortKey = sortKeyMap[k]
        if (k !== prop) {
          this.query[sortKey] = null
        } else {
          if (order === 'ascending') {
            this.query[sortKey] = 1
          } else {
            this.query[sortKey] = -1
          }
        }
      }
      this.doQueryList({ pageNo: 1 })
    },
    doQueryList({ pageNo, pageSize }) {
      if (pageNo) {
        this.query.pageNo = pageNo
      }
      if (pageSize) {
        this.query.pageSize = pageSize
      }
      if (this.orderToday) {
        this.query.endTime = this.startTime ? this.startTime + ' 00:00:00' : ''
        this.query.startTime = this.endTime ? this.endTime + ' 23:59:59' : ''
      }
      this.listLoading = true
      return sysTaskApi.fetchList(this.query).then(data => {
        let { list, total } = data.data;
        this.list = list
        this.total = total
      }).finally(() => {
        this.listLoading = false
      })
    },
    handleShow(row){
      this.$refs.taskShow.handleShow(row)
    }
  }
}
</script>
<style lang="scss" scoped>
.tab-box {
  margin-bottom: 20px;
  span {
    margin-right: 20px;
    font-size: 20px;
    color: #6c6c6c;
    cursor: pointer;
    &.active {
      color: #1596cd;
    }
  }
}
</style>
